module.exports = "fonts/playfair-display-v15-latin-700.woff";